import { api } from "./api";

export const logsListApi = (params) => {
    return api.get(`/logs/list`, { params: params });
};

export const logsExportApi = (params) => {
    return api.get(`/logs/export`, { params, responseType: 'blob' });
};

export const logsViewApi = (id) => {
    return api.get(`/logs/view`, { params: { id } });
};

export const getSignedUrlApi = (fileUrl) => {
    return api.post(`/translation/signed-url`, { fileUrl });
};